import PropTypes from "prop-types";

import Dollar from "./Dollar";

export default function DataGridCell({ isDollar, style = {}, value }) {
  return (
    <span style={{ textAlign: "center", whiteSpace: "pre-line", ...style }}>
      {isDollar ? <Dollar toFixed={0}>{value}</Dollar> : value}
    </span>
  );
}

DataGridCell.propTypes = {
  isDollar: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
};
